import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { repairCollapsedMarkdownTables } from '../utils/repairCollapsedMarkdownTables';

interface ChatMarkdownProps {
  content: string;
}

/**
 * Renders assistant replies with GFM tables, lists, and headings.
 */
const ChatMarkdown: React.FC<ChatMarkdownProps> = ({ content }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]}>
    {repairCollapsedMarkdownTables(content)}
  </ReactMarkdown>
);

export default ChatMarkdown;
